import React from 'react';
import DfbHeadline from '../ui-kit/dfb_headline';
import DfbSymbol from "../ui-kit/dfb_symbol"
import DfbButton from '../ui-kit/dfb_button';
import DfbParagraph from "../ui-kit/dfb_paragraph"


const CCardCta = (props) => {
    /**
     * Attention: CMS has an explicit Structure for c_card_cta called "c_card_cta_item"
     * All modules containing this Structure have to be handled.
     * Currently the m_card_grid_cta and m_card_row_cta module containing different structures for c_card_cta
     * These modules have to contain the "use_c_card_cta_item_structure = true" in the data object.
     * Please take a look on usage of c_card_cta in these modules.
     */
    const { use_c_card_cta_item_structure } = props.data
    if(use_c_card_cta_item_structure && use_c_card_cta_item_structure === true) {
        const { card_cta_icon, card_cta_headline, card_cta_description, card_cta_link_obj, card_cta_alternative } = props.data

        //WIP: remove "dfb-icon-"" from key for now. CMS will change
        const card_cta_clean_icon = card_cta_icon.replace('dfb-icon-', '')

        const testid = props.data.testid ? props.data.testid : null

        return (
            <div className="c-CardCta c-CardCta--cta c-CardCta-card dfb-Card">
                <div className="c-CardCta-container">
                    <div className="c-CardCta-card">
                        <div className="dfb-Card-content" data-testid={testid}>
                            {card_cta_clean_icon && <DfbSymbol icon_type={card_cta_clean_icon} add_class="c-CardCta-icon" />}
                            {card_cta_headline && (
                                <DfbHeadline headline={card_cta_headline} headline_level="h4" add_class="u-Theme-dark c-CardCta-headline" />
                            )}
                            {card_cta_description && <DfbParagraph text={card_cta_description} add_class="c-CardCta-description" />}
                            {card_cta_link_obj?.url && (
                                <DfbButton
                                    tagName="a"
                                    link={card_cta_link_obj.url}
                                    text={card_cta_alternative}
                                    external={card_cta_link_obj.type !== 'page'}
                                    add_class="u-Theme-dark c-CardCta-button"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        const { icon, headline, description, button, testid } = props.data

        return (
            <div className="c-CardCta dfb-Card">
                <div className="c-CardCta-container">
                    <div className="c-CardCta-card">
                        <div className="dfb-Card-content" data-testid={testid}>
                            {icon &&
                                <div className="c-CardCta-icon">
                                    <DfbSymbol icon_type={icon} add_class="c-CardCta-icon" />
                                </div>
                            }
                            {headline && <div className="c-CardCta-headline">
                                <DfbHeadline
                                    headline={headline}
                                    headline_level="h4"
                                    add_class="u-Theme-dark"
                                />
                            </div>}
                            {description &&
                                <DfbParagraph
                                    text={description}
                                    add_class="c-CardCta-description"
                                />
                            }
                            {button && <DfbButton
                                tagName="a"
                                link={button.href}
                                text={button.label}
                                external={button.externalLink}
                                add_class="u-Theme-dark c-CardCta-button"
                            />
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

};

export default CCardCta;
